import React, { Component } from 'react';
import axios from "axios";

import api from '../../../../api/';
import ParadigmaTable from "../../../../components/ParadigmaTable/";

class TiposDoc extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "Código",
                    id: "Codigo",
                    accessor: "Codigo",
                    show: true,
                    width: 150,
                },
                {
                    Header: "Nombre",
                    id: "Nombre",
                    accessor: d => d.Nombre,
                    show: true,
                },
                {
                    Header: "De Baja",
                    id: "DeBaja",
                    accessor: d => d.DeBaja ? "SI" : "NO",
                    show: true,
                    filterable: true,
                    lookup:"exact",
                    Filter: ({ filter, onChange }) =>(
                         <select
                         onChange={event => onChange(event.target.value)}
                         style={{ width: "100%" }}
                         value={filter ? filter.value : ""}>
                         <option value="">TODOS</option>
                         <option value={"True"}>SI</option>
                         <option value={"False"}>NO</option>
                         </select>
                    ),
                    width: 100,
                    className:"text-center",
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        const { modernTheme } = this.props;
        return (
            <ParadigmaTable
                modernTheme={modernTheme}
                buttons={[]}
                outerFilter={[{id:"DeBaja", lookup:"exact", value:"False"}]}
                apiUrl={api.gestion.generales.tiposdoc}
                columns={this.state.columns}
                title={"Tipos de Documento"}
            />
        );
    }
}

export default TiposDoc;



// WEBPACK FOOTER //
// ./src/views/Gestion/Generales/TiposDoc/TiposDoc.js